const iframesToSearch = [
  { c: '[src*=doubleclick]', t: 'advertisement' },
  { c: '[id=juStore]', t: 'advertisement' },
  { c: '[src*=pay\\.google]', t: 'google pay is enabled' },
  { c: '[src*=rise-ai]', t: 'gifts enabled' },
  { c: '[src*=covet\\.pics]', t: 'instagram pictures enabled' },
  { c: '[src*=googletagmanager]', t: 'google enabled' },
  { c: '[src*="web-pixel"]', t: 'Shopify web pixel sandbox frame' }
];

function setIframeTitle(node) {
  if (node.hasAttribute('title')) return;

  let matched = false;
  iframesToSearch.forEach(iframe => {
    if (node.matches('iframe' + iframe.c)) {
      node.setAttribute('title', iframe.t);
      matched = true;
    }
  });

  if (!matched) node.setAttribute('title', 'Embedded frame');
}

document.querySelectorAll('iframe').forEach(setIframeTitle);

const iframeObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeName === 'IFRAME') {
        setIframeTitle(node);
      } else if (node.nodeName === 'DIV' && node.matches('.shg-lightbox')) {
        const img = node.querySelector('img.shg-lightbox-image');
        if (img) img.setAttribute('alt', 'Pop up image');
      }
    });
  });
});

iframeObserver.observe(document.body, { childList: true, subtree: true });

  const iframeA11yTitleSet = () => {
    document.querySelectorAll('iframe').forEach(frame => {
      const datasetSrc = frame.dataset.src;
      const src = frame.src;

      // Check if datasetSrc or src is a valid URL
      let url = null;
      try {
        url = new URL(datasetSrc || src);
      } catch (e) {
        return;
      }

      if (url.hostname === 'www.youtube.com') frame.setAttribute('title', 'Youtube video');
    });

    document.querySelectorAll('.recommendation-modal__close-button').forEach(button => button.setAttribute('title', 'Location close'));
    document.querySelectorAll('.recommendation-modal__flag img').forEach(img => img.setAttribute('alt', 'Flag'));
    document.querySelectorAll('.recommendation-modal__message, .recommendation-modal__benefits ul li, .recommendation-modal__button--minimal')
      .forEach(el => el.style.color = '#6e777e');
  };

  const iframeA11yTitleSetInterval = setInterval(iframeA11yTitleSet, 100);

  setTimeout(() => clearInterval(iframeA11yTitleSetInterval), 5000);